// Lib
import { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

import { RECRUITER, EMPLOYER } from 'constants/index';
import { UserTokenType } from 'types/global';
import { signInAdminAsUser, backToAdminFromUser } from '../actions';

const getUsersList = createSelector(
  (state: any) => state.allUsers,
  (_: any, userRoleType: string) => userRoleType,
  (allUsers, userRoleType) => {
    if (userRoleType === RECRUITER) {
      return allUsers.recruiters;
    }
    return allUsers.employers;
  }
);

const useAdmin = () => {
  const [userRoleType, setUserRoleType] = useState(RECRUITER);

  const dispatch = useDispatch();

  const adminToken = useSelector<any, UserTokenType>((state: any) => state.admin.token);

  const recruiterRoleTypeHandler = useCallback(() => setUserRoleType(RECRUITER), []);
  const employerRoleTypeHandler = useCallback(() => setUserRoleType(EMPLOYER), []);
  const userLinkHandler = useCallback(userId => dispatch(signInAdminAsUser(userId)), [dispatch]);

  const backToAdminFromUserHandler = useCallback(() => dispatch(backToAdminFromUser()), [dispatch]);

  const usersList = useSelector((state: any) => getUsersList(state, userRoleType));

  return {
    adminToken,
    userRoleType,
    usersList,
    recruiterRoleTypeHandler,
    employerRoleTypeHandler,
    userLinkHandler,
    backToAdminFromUserHandler,
  };
};

export default useAdmin;
